var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable max-len */
import { hideApplicationLoader } from 'common/ApplicationLoader';
import { getDevicesTypeService } from 'services/deviceService/device.service';
import { showError } from 'store/commonReducer/common.action';
export var GET_DEVICES_LIST = 'GET_DEVICES_LIST';
export var GET_DEVICES_LIST_SUCCESS = 'GET_DEVICES_LIST_SUCCESS';
export var GET_DEVICES_LIST_FAIL = 'GET_DEVICES_LIST_FAIL';
export var UPDATE_DEVICES_LIST_PAGE_NUMBER = 'UPDATE_DEVICES_LIST_PAGE_NUMBER';
export var RESET_DEVICES_LIST = 'RESET_DEVICES_LIST';
export var GET_DEVICES_SEARCH_LIST_SUCCESS = 'GET_DEVICES_SEARCH_LIST_SUCCESS';
export var SET_DEVICE_TYPE_VALUE = 'SET_DEVICE_TYPE_VALUE';
export var SET_DEVICE_SEARCH_QUERY = 'SET_DEVICE_SEARCH_QUERY';
/**
 * @function getDeviceType
 * @description action creator to fetch device data
 * @param {string} searchQuery
 * @param {string} deviceType
 */
export var getDeviceType = function (searchQuery, deviceType) {
    if (searchQuery === void 0) { searchQuery = ''; }
    if (deviceType === void 0) { deviceType = ''; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!searchQuery && !deviceType) {
                        dispatch({ type: GET_DEVICES_LIST_SUCCESS, payload: { data: [] } });
                        return [2 /*return*/, { data: [], lastEvaluatedKey: '' }];
                    }
                    payload = {};
                    if (searchQuery) {
                        payload.serial = searchQuery;
                    }
                    if (deviceType) {
                        payload.deviceType = deviceType;
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    dispatch({ type: GET_DEVICES_LIST });
                    return [4 /*yield*/, getDevicesTypeService(payload)];
                case 2:
                    response = _a.sent();
                    dispatch(hideApplicationLoader());
                    return [2 /*return*/, {
                            data: response || [],
                        }];
                case 3:
                    error_1 = _a.sent();
                    dispatch(hideApplicationLoader());
                    dispatch({ type: GET_DEVICES_LIST_FAIL });
                    dispatch(showError(error_1));
                    throw error_1;
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * @function getDeviceListSuccess
 * @description action creator to set device data on success
 */
export var getDeviceListSuccess = function (data) { return function (dispatch) {
    dispatch({
        type: GET_DEVICES_LIST_SUCCESS,
        payload: { data: data || [] },
    });
}; };
/**
 * @function getDeviceSearchListSuccess
 * @description action creator to set searched device data
 */
export var getDeviceSearchListSuccess = function (data, searchLastEvaluatedKey, searchQuery) {
    if (searchLastEvaluatedKey === void 0) { searchLastEvaluatedKey = ''; }
    if (searchQuery === void 0) { searchQuery = ''; }
    return function (dispatch) {
        dispatch({
            type: GET_DEVICES_SEARCH_LIST_SUCCESS,
            payload: {
                data: data,
                searchLastEvaluatedKey: searchLastEvaluatedKey,
                searchQuery: searchQuery,
            },
        });
    };
};
/**
 * @function getDeviceListFail
 * @description action creator when fetching device list fails
 */
export var getDeviceListFail = function (error) { return function (dispatch) {
    dispatch(showError(error));
    dispatch({ type: GET_DEVICES_LIST_FAIL });
}; };
/**
 * @function updateDevicePageNumber
 * @description action creator to update the page number of device list table
 */
export var updateDevicePageNumber = function (value) { return function (dispatch) {
    dispatch({
        type: UPDATE_DEVICES_LIST_PAGE_NUMBER,
        payload: value,
    });
}; };
/**
 * @function resetDeviceList
 * @description action creator to reset device list
 */
export var resetDeviceList = function () { return function (dispatch) {
    dispatch({ type: RESET_DEVICES_LIST });
}; };
/**
 * @function setDeviceType
 * @description action creator to set device type filter
 */
export var setDeviceType = function (value) { return function (dispatch) {
    dispatch({
        type: SET_DEVICE_TYPE_VALUE,
        payload: value,
    });
}; };
/**
 * @function setDeviceSearchQuery
 * @description action creator to set device search query
 */
export var setDeviceSearchQuery = function (query) { return function (dispatch) {
    dispatch({
        type: SET_DEVICE_SEARCH_QUERY,
        payload: query,
    });
}; };
